var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-stretch w-100 ui-mh-100vh ui-bg-cover ui-bg-overlay-container",staticStyle:{"background-image":"url(/assets/img/bg/30.jpg)"}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }